/**
 * Web sound preferences — persisted enabled + volume + pack (localStorage),
 * wired so every write (and rehydration) pushes straight into the player:
 * muting silences everything immediately via the shared core, and a pack
 * change re-points every cue.
 */

import {
  applySoundPack,
  applySoundsEnabled,
  applySoundVolume,
  createSoundPrefsStore,
} from '@flashka/shared/sound';

const prefs = createSoundPrefsStore({
  storage: localStorage,
  name: 'flashka.sound-prefs',
  version: 3, // v2 adds `volume`, v3 adds `pack`
  onEnabledChange: applySoundsEnabled,
  onVolumeChange: applySoundVolume,
  onPackChange: applySoundPack,
});

export const useSoundsEnabled = prefs.useSoundsEnabled;
export const getSoundsEnabled = prefs.getSoundsEnabled;
export const setSoundsEnabled = prefs.setSoundsEnabled;
export const useSoundVolume = prefs.useVolume;
export const useSoundPack = prefs.usePack;
export const getPack = prefs.getPack;
export const setSoundPack = prefs.setPack;
export const getVolume = prefs.getVolume;
export const setSoundVolume = prefs.setVolume;
